import {useStore} from '@/store/root-store';
import {faArrowLeft, faXmark} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import classNames from 'classnames';
import {useEffect, useState} from 'react';
import {opaqueColor} from '@/utils/colors';
import {faRotateLeft} from '@fortawesome/pro-solid-svg-icons';
import {toJS} from 'mobx';
import {LinkAssistantRightSidebar} from './linkAssistantRightsideBar';

export const TextSuggestionsLinks = observer(() => {
  const {
    contentOptimizer: {
      currentPage: {
        content,
        setIsLinkActive,
        setLinksForInsertion,
        getstagingLinkSuggestions,
        linkActiveTerm,
        setLinkActiveTerm,
        setStagingLinkSuggestions,
        isLinkActive,
        highlightedNodeId,
        setHighlightedNodeId,
        showOriginalBlockId,
        setShowOriginalBlockId,
        updatingTa,
        clearAllTaData,
      },
    }} = useStore('');

  const [totalOccurances, setTotalOccurances] = useState<number>(document.getElementsByClassName(linkActiveTerm?.class)?.length ?? 0);
  useEffect(() => {
    setTotalOccurances(document.getElementsByClassName(linkActiveTerm?.class || linkActiveTerm?.class)?.length);
  }, [linkActiveTerm?.class, linkActiveTerm?.class]);

  const onArrowClickHandler = (direction: 'next' | 'prev') => {
    setTotalOccurances(document.getElementsByClassName(linkActiveTerm.class)?.length ?? 0);

    const updatedValues = {
      class: linkActiveTerm.class,
      term: linkActiveTerm.term,
      order: direction == 'next' ? linkActiveTerm.order + 1 : linkActiveTerm.order - 1,
    };

    setShowOriginalBlockId(null);
    setLinkActiveTerm(updatedValues);
  };


  useEffect(() => {
    if (linkActiveTerm) {
      setShowOriginalBlockId(null);
      const nodesWithTerm = document.getElementsByClassName(`${linkActiveTerm.class}`);
      if (nodesWithTerm?.length) {
        const higlightedNode = nodesWithTerm[0];
        if (!higlightedNode) return;
        setHighlightedNodeId(+(higlightedNode as HTMLElement)?.dataset?.blockIndex);
        const elemOffset = (higlightedNode as HTMLElement).offsetTop;
        document.querySelector('.textContainer').scrollTop = elemOffset - ((window.innerHeight - 170) / 2);
      }
    }
  }, [linkActiveTerm?.term, linkActiveTerm?.order, linkActiveTerm?.class, linkActiveTerm]);


  const blocksRenderer = blocksArray => {
    const options = {
      replace: domNode => {
        if (!domNode.attribs) {
          return;
        }
      },
    };

    const typeDettector = (text: string) => {
      if (text.startsWith('<p>')) {
        return 'p';
      }
      if (text.startsWith('<h1>')) {
        return 'h1';
      }
      if (text.startsWith('<h2>')) {
        return 'h2';
      }
      if (text.startsWith('<h3>')) {
        return 'h3';
      }
      if (text.startsWith('<h4>')) {
        return 'h4';
      }
      if (text.startsWith('<h5>')) {
        return 'h5';
      }
      if (text.startsWith('<h6>')) {
        return 'h6';
      }

      return 'p';
    };

    const checkKey = e => {
      e = e || window.event;

      if (e.keyCode == '38') {
        // up arrow
        if (linkActiveTerm?.order == 0) return;
        onArrowClickHandler('prev');
      } else if (e.keyCode == '40') {
        // down arrow
        if (linkActiveTerm?.order == (totalOccurances > 0 ? totalOccurances - 1 : 0)) return;
        onArrowClickHandler('next');
      } else if (e.keyCode == '37') {
        // left arrow
      } else if (e.keyCode == '39') {
        // right arrow
      }
    };

    document.onkeydown = checkKey;

    const onBlockStatusChange = (action: 'accept' | 'dismiss' | 'undo') => {
      let prepDataArr = toJS(getstagingLinkSuggestions);
      prepDataArr = prepDataArr?.map(item => {
        if (item.itemIndex == highlightedNodeId) {
          return {
            ...item,
            ...(action == 'accept' && {status: 'accepted'}),
            ...(action == 'dismiss' && {status: 'dismissed'}),
            ...(action == 'undo' && {status: 'default'}),
          };
        } else {
          return item;
        }
      });
      setStagingLinkSuggestions([...prepDataArr]);
    };

    return <TextContainer className='textContainer'>
      {blocksArray?.map((block, idx) => {
        const regExp = /(<\/?\w+(?:(?:\s+\w+(?:\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/?>)/gim;
        const parser = new DOMParser();
        const doc = parser.parseFromString(block.suggestion, 'text/html');
        // Find elements with classname 'hero'
        const elements = doc.querySelectorAll('.linkInsertionChange');
        const suggestionList = [];
        // Extract innerText from each element
        elements.forEach((ele:any)=>{
          suggestionList.push({keyword: ele.innerText, status: 'default'});
        });

        if (block.isSuggestion) {
          return (
            <>
              <SingleBlockWithSuggestion
                showingOriginalBlock={showOriginalBlockId && showOriginalBlockId == block.itemIndex}
                currNodeId={highlightedNodeId}
                status={block.status}
                key={idx}
                type={typeDettector(block.suggestion)}
                data-block-index={block.itemIndex}
                // eslint-disable-next-line no-unsafe-optional-chaining
                className={classNames(...((suggestionList)?.map(term => term.keyword?.replaceAll(' ', '-')+`${block?.itemIndex}`)), block.status)}>
                {showOriginalBlockId != null && showOriginalBlockId == block.itemIndex ?
                  <div
                    style={{position: 'absolute', right: '-20px', top: 0, cursor: 'pointer', width: 20, textAlign: 'center'}}
                    onClick={() => setShowOriginalBlockId(null)}>
                    <FontAwesomeIcon icon={faXmark} fontSize={16} color='#121212'/>
                  </div> : null}

                {highlightedNodeId == block.itemIndex && (showOriginalBlockId != null || showOriginalBlockId != block.itemIndex) ?
                  <div style={{position: 'absolute', top: 10, fontSize: 12, color: '#2D6CCA', cursor: 'pointer', zIndex: '9999'}} onClick={() => {
                    setShowOriginalBlockId(block.itemIndex);
                  }}>
                    {showOriginalBlockId == null && 'Show original'}
                  </div> : null}

                {(showOriginalBlockId != null) && showOriginalBlockId == block.itemIndex && block.status !== 'default' ?
                  <span style={{
                    position: 'absolute',
                    textTransform: 'uppercase',
                    top: 5,
                    fontSize: 12,
                    color: block.status == 'accepted' ? '#1FAC47' : '#F44343',
                  }}>{block.status}</span> : null}
                <div style={{pointerEvents: 'none'}} >
                  {highlightedNodeId !== block.itemIndex && block.status == 'dismissed' ? parse(block.html?.replaceAll('<br/>', '\n\n')?.replaceAll('&lt;br/&gt;', '\n')?.split(regExp)?.join(' '), options) : parse(block.suggestion?.replaceAll('<br/>', '\n\n')?.replaceAll('&lt;br/&gt;', '\n')?.split(regExp)?.join(' '), options)}
                </div>

              </SingleBlockWithSuggestion>
              {(showOriginalBlockId != null) && showOriginalBlockId == block.itemIndex ?
                <SingleBlockWithSuggestion
                  showingOriginalBlock={(showOriginalBlockId != null) && showOriginalBlockId == block.itemIndex}
                  currNodeId={highlightedNodeId}
                  status={block.status}
                  key={idx}
                  type={typeDettector(block.suggestion)}
                  className={'originalBlock'}>
                  <div style={{display: 'flex', alignItems: 'center', marginTop: -10}}>
                    <div style={{color: '#2d6cca', fontSize: 12, fontWeight: 500}}>ORIGINAL</div>
                    {block.status !== 'default' && block.status !== 'dismissed' ?
                      <div
                        style={{
                          backgroundColor: opaqueColor('#2D6CCA', 15),
                          padding: '5px 15px',
                          color: '#2D6CCA',
                          borderRadius: 6,
                          cursor: 'pointer',
                          zIndex: 9999,
                          marginLeft: 20,
                        }}
                        onClick={() => {
                          onBlockStatusChange('undo');
                          setShowOriginalBlockId(null);
                        }}> <FontAwesomeIcon icon={faRotateLeft}/> Revert to Original </div> : null}
                  </div>
                  <div style={{pointerEvents: 'none'}} >
                    {parse(block.html?.replaceAll('<br/>', '\n\n')?.replaceAll('&lt;br/&gt;', '\n')?.split(regExp)?.join(' '), options)}
                  </div>
                </SingleBlockWithSuggestion> :
                null}
            </>

          );
        } else {
          return <BlockWrapper key={idx}>
            {parse(block.html?.replaceAll('<br/>', '\n\n')?.replaceAll('&lt;br/&gt;', '\n')?.split(regExp)?.join(' '), options)}
          </BlockWrapper>;
        }
      })}

    </TextContainer>;
  };

  return <Wrapper style={{height: isLinkActive ? '100%' : '0px'}}>
    <Heading>
      <FontAwesomeIcon icon={faArrowLeft} fontSize={16} onClick={() => {
        if (updatingTa) return false;
        setIsLinkActive(false);
        clearAllTaData();
        setLinksForInsertion([]);
      }} style={{cursor: 'pointer'}}/>
      <Title>{content.title}</Title>
    </Heading>
    <div style={{display: 'flex', justifyContent: 'space-between', paddingTop: '33px', height: '82vh'}}>
      {blocksRenderer(getstagingLinkSuggestions)}
      <LinkAssistantRightSidebar />
    </div>
  </Wrapper>;
});

const Wrapper = styled.div`
  position: relative;

  &::before {
    background-color: #24262a;
    content: '';
    height: 25px;
    left: 0;
    max-width: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }

  &::after {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    content: '';
    height: 5px;
    left: 0;
    max-width: 100%;
    position: absolute;
    top: 20px;
    width: 100%;
    z-index: 1;
  }
  padding-top: 25px;
`;

const Heading = styled.div`
  display: flex;
  background-color: #fff;
  padding: 19px 30px;
  align-items: center;
  cursor: default;
`;
const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: #121212;
  margin-left: 20px;
  line-height: 20px;
`;
const TextContainer = styled.div`
  padding-top: 45px;
  padding-bottom: 170px;
  width: 65%;
  max-width: 90%;
  text-align: left;
  height: calc(100vh - 170px);
  overflow-y: auto;
  padding-left:10%;
  padding-right:40px;
  color: rgba(0, 0, 0, 0.85);
  border-right: 1px solid lightgray;
  .linkInsertionChange {
    text-decoration: underline;
  }
  p a{
    color: rgba(0, 0, 0, 0.85);
  }
  .default p span a{
    color: #1890ff;
  }
  .accepted{
   span a{
    text-decoration: underline;
    color: #1FAC47 !important;
    text-decoration-color: #1FAC47 !important;

   }
  }
  .dismissed{
   span a{
    text-decoration: underline;
    color: #F44343 !important;
    text-decoration-color: #F44343 !important;
   }
  }
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #4E515680;
    border-radius: 5px;
  }

  
`;

const SingleBlockWithSuggestion = styled.span<{type: string; status: 'default' | 'accepted' | 'dismissed'; currNodeId: number; showingOriginalBlock: boolean}>`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  display: block;
  position: relative;


  &[data-block-index='${p => p.currNodeId}'], &.originalBlock {
    width: calc(100% + 60px) !important;
    padding-left: 40px;
    padding-right: 20px;
    padding-top: 25px;
    padding-bottom: 25px;
    position: relative;
    box-shadow: 1px 4px 4px rgba(211, 83, 119, 0.05);
    background: #fff;
    margin-left: -40px;
    margin-right: -40px;

    &::before {
      left: 10px;
      top: 25px;
    }

     &::after {
      position: absolute;
      display: block;
      content: '';
      top: 0;
      left:0;
      width: 100%;
      height: 100%;
      
     }


    .termsAssistantFocusTerm {
      background: ${p => p.status == 'accepted' || p.status == 'default' ? `linear-gradient(89.25deg, ${opaqueColor('#1FAC47', 20)} 2.9%, ${opaqueColor('#1FAC47', 20)} 2.91%, ${opaqueColor('#3FD369', 20)} 96.24%)` : `linear-gradient(90.16deg, ${opaqueColor('#E15E83', 20)} 2.81%, ${opaqueColor('#F58069', 20)} 96.58%)`};
      text-decoration: none !important;
      text-decoration-color: ${p => p.status == 'accepted' || p.status == 'default' ? '#1FAC47' : '#F44343'} !important;

    }
  }
    &[data-block-index='${p => p.currNodeId}'] {
      border-radius: ${p => p.showingOriginalBlock ? '16px 16px 0 0' : '16px'};
      &::after {
        border-radius: ${p => p.showingOriginalBlock ? '16px 16px 0 0' : '16px'};
        border: 1px dashed ${p => p.status == 'accepted' ? '#1FAC47' : p.status == 'dismissed' ? '#F44343' : '#2D6CCA'};
      }
    }

    &.originalBlock {
      border-radius: ${p => p.showingOriginalBlock ? '0 0 16px 16px' : '16px'};
      margin-top: -20px;
      &::after {
        border-radius: ${p => p.showingOriginalBlock ? '0 0 16px 16px' : '16px'};
        border: 1px dashed #2D6CCA;
      }
    }

  &::before {
    content: '${p => p.type}';
    position: absolute;
    left: -30px;
    top: 0px;
    font-size: 12px;
    font-weight: 600;
    color: #A3A4A4;
  }
  .termsAssistantFocusTerm {
    color: ${p => p.status == 'accepted' ? '#1FAC47' : p.status == 'dismissed' ? '#F44343' : 'inherit'};
    text-decoration: ${p => p.status == 'dismissed' ? 'line-through' : 'none'};
    text-decoration-color: ${p => p.status == 'accepted' ? '#1FAC47' : p.status == 'dismissed' ? '#F44343' : 'inherit'} !important;
  }
`;

const BlockWrapper = styled.div`
  pointer-events: none;
  img {
    width: 100%;
  }
`;


